import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { CodeComponent } from "./CodeComponent";
import { blue, green, red } from "@material-ui/core/colors";
import { useSelector } from "react-redux";
import {
  formTemplate,
  inputValuesTemplate,
  inputsValidatesTemplate,
} from "./templates";

const style = {
  borderRadius: 12,
};

export const CodePreview = () => {
  const { inputs } = useSelector(
    ({ formGeneratorReducer }) => formGeneratorReducer
  );
  const [formCode, setFormCode] = useState();
  const [valuesCode, setValuesCode] = useState();
  const [validationsCode, setValidationsCode] = useState();

  useEffect(() => {
    setFormCode(formTemplate(inputs));
    setValuesCode(inputValuesTemplate(inputs));
    setValidationsCode(inputsValidatesTemplate(inputs));
  }, [inputs]);
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={style}>
        <CodeComponent
          code={formCode}
          height={380}
          color={blue[50]}
          color2={blue[200]}
        />
      </Grid>
      <Grid item xs={12} sm={6} style={style}>
        <CodeComponent
          code={valuesCode}
          height={200}
          color={green[50]}
          color2={green[200]}
        />
      </Grid>
      <Grid item xs={12} sm={6} style={style}>
        <CodeComponent
          code={validationsCode}
          height={200}
          color={red[50]}
          color2={red[200]}
        />
      </Grid>
    </Grid>
  );
};
